var map = {
	"./error-icon.svg": 239570,
	"./exists-order-icon.svg": 452056,
	"./success-icon.svg": 68709,
	"./whatsapp-icon.svg": 39538,
	"./whatsapp-small-icon.svg": 126505,
	"./work-order-icon.svg": 863497
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 197859;